module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Italic-2171665508e87b63ab462307d21e7cb0.woff2";